const normalizeLang = (value: string): string => (value || '').toLowerCase().split('-')[0];

const extractLanguagesFromValue = (value: any): string[] => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return [];
  return Object.keys(value).map(normalizeLang).filter(Boolean);
};

export const getCourseAvailableLanguages = (course: any): string[] => {
  const langs = new Set<string>();

  if (Array.isArray(course?.availableLanguages)) {
    course.availableLanguages.forEach((lang: string) => {
      const normalized = normalizeLang(lang);
      if (normalized) langs.add(normalized);
    });
  }

  [
    course?.title,
    course?.description,
    course?.welcomeMessage
  ].forEach((value) => {
    extractLanguagesFromValue(value).forEach((lang) => langs.add(lang));
  });

  (course?.chapters || []).forEach((chapter: any) => {
    [chapter?.title, chapter?.description, chapter?.summary].forEach((value) => {
      extractLanguagesFromValue(value).forEach((lang) => langs.add(lang));
    });
  });

  return Array.from(langs);
};

export const isCourseLanguageAvailable = (course: any, lang: string): boolean => {
  const available = getCourseAvailableLanguages(course);
  return available.includes(normalizeLang(lang));
};
